export function IsTargetData(info, name) {
    let func = {
        //予約状況(bookingState)以外による判定
        //予約状況は条件に入れないこと
        companyId             : ()=>info.holderType==1,
        holderName            : ()=>info.holderType==2,
        holderTel             : ()=>info.holderType==2,
        infoBarthDateFlag     : ()=>[1,2,4,5].some(x=>info.infoType==x),
        infoBarthDate         : ()=>[1,2,4,5].some(x=>info.infoType==x) && info.infoBarthDateFlag==0,
        infoAge               : ()=>[1,2,4,5].some(x=>info.infoType==x),
        infoPregnancy         : ()=>[3].some(x=>info.infoType==x),
        infoDeathDate         : ()=> info.infoDeathDateFlag==0,
        infoDeathTime         : ()=> info.infoDeathTimeFlag==0,
        infoReportAreaId      : ()=>[1,2,4].some(x=>info.infoType==x),
        infoSpacialCase1      : ()=>[1,2,4].some(x=>info.infoType==x),
        infoSpacialCase2      : ()=>[1,2,4].some(x=>info.infoType==x),
        infoWeight            : ()=>[1,2,4].some(x=>info.infoType==x),
        infoComeFrom          : ()=>[1,2,4].some(x=>info.infoType==x),
        infoFatherName1       : ()=>info.infoType==3,
        infoFatherName2       : ()=>info.infoType==3,
        infoFatherKana1       : ()=>info.infoType==3,
        infoFatherKana2       : ()=>info.infoType==3,
        infoMotherName1       : ()=>info.infoType==3,
        infoMotherName2       : ()=>info.infoType==3,
        infoMotherKana1       : ()=>info.infoType==3,
        infoMotherKana2       : ()=>info.infoType==3,
        infoCremationPermit   : ()=>true,
        plateExName1          : ()=>info.usePlate==3,
        plateExName2          : ()=>info.usePlate==3,
        platePrefix           : ()=>info.usePlate>=2,
        announceName          : ()=>info.useAnnounce>=2,
        useFacility2Start     : ()=>info.useFacility2==2,
        useFacility2End       : ()=>info.useFacility2==2,
        useFacility2StartTime : ()=>info.useFacility2==2,
        useFacility2EndTime   : ()=>info.useFacility2==2,
    }
    //上記以外は常に表示
    return (name in func) ? func[name]() : true
}

export function BookingInfoSelections(){
    return {
        infoType : ()=>{
            return [
                [1, "大人(16歳以上)"],
                [2, "小人(16歳未満)"],
                [3, "死胎"],
                [4, "改葬遺骨"],
                [5, "身体の一部等"],
            ]
        },
        infoSex : ()=>{
            return [
                [1, "男性"],
                [2, "女性"],
                [3, "不詳"],
            ]
        },
        infoCremationPermit : ()=>{
            return [
                [1, "添付する"],
                [2, "FAXで送る"],
            ]
        },
        infoAge : ()=>{
            let ret = [["不詳", "不詳"]]
            for(let i=0; i<=120; i++)
                ret.push([`${i}歳`, `${i}歳`])
            return ret
        },
        infoPregnancy : ()=>{
            let ret = [["不詳", "不詳"]]
            for(let i=1; i<=12; i++)
                ret.push([`妊娠${i}ヵ月`, `妊娠${i}ヵ月`])
            for(let i=0; i<=50; i++)
                ret.push([`妊娠${i}週`, `妊娠${i}週`])
            return ret
        },
        infoWeight : ()=>{
            return [
                ['100kg未満', '100kg未満'],
                ['100kg', '100kg'],
                ['110kg', '110kg'],
                ['120kg', '120kg'],
                ['130kg', '130kg'],
                ['140kg', '140kg'],
                ['150kg', '150kg'],
                ['160kg', '160kg'],
                ['170kg', '170kg'],
                ['180kg', '180kg'],
                ['190kg', '190kg'],
                ['200kg', '200kg'],
            ]
        },
        infoSpacialCase1 : ()=>{
            return [
                [2,'一類感染症等'],
                [1,'その他'],
            ]
        },
        infoSpacialCase2 : ()=>{
            return [
                [2,'あり'],
                [1,'なし']
            ]
        },
        mournerCount : ()=>{
            let ret = [["なし","なし"]]
            for(let i=1; i<=100; i++)
                ret.push([`${i}人`, `${i}人`])
            return ret
        },
        useWaitingRoom : ()=>{
            return [
                [2,'あり'],
                [1,'なし'],
            ]
        },
        usePlate : ()=>{
            return [
                [2,'案内あり'],
                [3,'指定する'],
                [1,'なし']
            ]
        },
        platePrefix : ()=>{
            return [
                ['故','故'],
                ['様','様'],
                ['家','家'],
                ['なし','なし'],
            ]
        },
        useAnnounce : ()=>{
            return [
                [2,'放送あり'],
                [1,'なし']
            ]
        },
        religion : ()=>{
            return [
                [1,'仏式'],
                [2,'神式'],
                [3,'キリスト'],
                [4,'無宗教'],
                [10,'その他'],
            ]
        },
        userFacility1 : ()=>{
            return [
                [2,'使用する'],
                [1,'なし'],
            ]
        },
        userFacility2 : ()=>{
            return [
                [2,'使用する'],
                [1,'なし'],
            ]
        },
        exempted : ()=>{
            return [
                [0,''],
                [1,'減免'],
            ]
        }
    }
}